import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  securityText: {
    marginTop: '-5px',
    marginLeft: '5px',
  },
}));
